import http from './api'

const route = '/usuario_produtor/'

export default {
    show: (chaveativacao) => (
        http.post(route + 'perfil_produtor', { chaveativacao: chaveativacao })
    ),

    listar: () => (
        http.get(route)
    ),

    salvar: (usuarioprodutor) => {
        return http.post(route, usuarioprodutor)
    },

    excluir: (chaveativacao) => {
        return http.delete(route + chaveativacao)
    },

    atualizar: (usuarioprodutor) => {
        return http.put(route, usuarioprodutor)
    },

    ativar: (usuarioprodutor) => {
        return http.patch(route + 'ativar', usuarioprodutor)
    },

    desativar: (chaveativacao) => {
        return http.post(route + 'desativar', { chaveativacao: chaveativacao })
    },

    verificaAcessoUsuario: (chaveativacao) => {
        return http.post(route + 'verifica_acesso', { chaveativacao: chaveativacao })
    },

    atualizaToken: (chaveativacao, token) => {
        return http.post(route + 'atualiza_token', { chaveativacao: chaveativacao, token: token })
    },

    reenviaCodigoAtivacao: (chaveativacao, whatsapp) => {
        return http.post(route + 'reenviar_codigo', { chaveativacao: chaveativacao, whatsapp: whatsapp })
    },
    enviaMensagem: (chaveativacao, enviaNotif) => {
        return http.put(route + 'settings', { chaveativacao: chaveativacao, enviaNotif: enviaNotif })
    },
    loginDemo: (codigodemo) => {
        return http.patch(route + 'logindemo', { codigodemo: codigodemo })
    },
}
